module.exports = __webpack_public_path__ + "img/mj2.fe0cbc13.png";